import React from 'react';
import styled from 'styled-components';
import IcRegularCustomer from './CustomerDetailIcons/IcRegularCustomer';
import IcVipCustomer from './CustomerDetailIcons/IcVipCustomer';
import Text from 'components/Text';
import IcNewCustomer from './CustomerDetailIcons/IcNewCustomer';
import { IAccountPackage } from 'features/customer/services/types/api';

interface IAccountPackageProps {
  accountPackage?: IAccountPackage;
  name?: string;
}

const AccountPackage = ({ accountPackage, name }: IAccountPackageProps) => {
  const backgroundColor = () => {
    switch (accountPackage) {
      case IAccountPackage.NEW:
        return '#FFC3C7';
      case IAccountPackage.VIP:
        return '#F6D465';
      case IAccountPackage.REGULAR:
        return '#FFB772';
      default:
        return '#FFC3C7';
    }
  };

  const renderIcon = () => {
    switch (accountPackage) {
      case IAccountPackage.NEW:
        return <IcNewCustomer />;
      case IAccountPackage.VIP:
        return <IcVipCustomer />;
      case IAccountPackage.REGULAR:
        return <IcRegularCustomer />;
      default:
        return <IcNewCustomer />;
    }
  };

  return (
    <HeaderStyled>
      <IconBoxStyled $backgroundColor={backgroundColor()}>
        {renderIcon()}
        <Text variant='H9'>{accountPackage || IAccountPackage.NEW} CUSTOMER</Text>
      </IconBoxStyled>
      <NameStyled>{name}</NameStyled>
    </HeaderStyled>
  );
};

export default AccountPackage;
const HeaderStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const IconBoxStyled = styled.div<{ $backgroundColor: string }>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  background: ${({ $backgroundColor }) => $backgroundColor};
`;

const NameStyled = styled.div`
  color: #1d2129;
  text-align: center;
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
`;
